const variables = {
	$EXTERNAL_API_NAME: '$API',
	gsapDefaultDuration: .25,
	carouselDefaultDuration: 800,
	resizeDebounce: 100,
	debugLogs: true,
	debugLogsDisabledNotify: true,
	customEventNames: {
		resize: 'resize-done',
		animateEnd: 'animate-end',
		articleSearchDone: 'catalog-search-run',
		rangeChanged: 'range-changed',
		modal: {
			open: 'modal-open',
			opened: 'modal-opened',
			close: 'modal-close',
			closed: 'modal-close-end'
		}
	},
	classNames: {
		touch: 'is-touch',
		disabled: 'is-disabled',
		active: 'is-active',
		lazyLoading: 'is-loading',
		lazyPreloader: 'lazy__preloader',
		lazyImage: 'lazy__image',
		lazyLoaded: 'is-loaded',
		blurred: 'is-blurred',
		involved: 'is-involved'
	},
	commonChoiceOpts: {
		classNames: {
			containerOuter: 'select',
			containerInner: 'select__inner',
			input: 'select__input',
			inputCloned: 'select__input--cloned',
			list: 'select__list',
			listItems: 'select__list--multiple',
			listSingle: 'select__list--single',
			listDropdown: 'select__list--dropdown',
			item: 'select__item',
			itemSelectable: 'select__item--selectable',
			itemDisabled: 'select__item--disabled',
			itemChoice: 'select__item--choice',
			placeholder: 'select__placeholder',
			group: 'select__group',
			groupHeading: 'select__heading',
			button: 'select__button',
			activeState: 'is-active',
			focusState: 'is-focused',
			openState: 'is-open',
			disabledState: 'is-disabled',
			highlightedState: 'is-highlighted',
			selectedState: 'is-selected',
			flippedState: 'is-flipped',
			loadingState: 'is-loading',
			noResults: 'has-no-results',
			noChoices: 'has-no-select'
		},
		itemSelectText: 'Выбрать',
		noResultsText: 'Ничего не найдено',
		loadingText: 'Загрузка',
		noChoicesText: 'Нечего выбрать',
		searchEnabled: false,
	},
	multipleChoiceOpts: {
		searchChoices: false,
		editItems: true,
		maxItemCount: 10,
		removeItemButton: true,
		placeholder: false,
		placeholderValue: null,
		searchPlaceholderValue: false,
		maxItemText(maxItemCount) {
			return `Только ${maxItemCount} пунктов может быть выбрано`
		}
	},
	get windowWidth() {
		return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
	},
	get windowHeight() {
		return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
	},
	scrollbarWidth:	window.innerWidth - document.documentElement.clientWidth,
	breakpoints: {
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1240,
	},
	scrollbarDefaults: {
		damping: .08,
		alwaysShowTracks: true
	},
	dom: {
		header: document.getElementById('js-page-header'),
		footer: document.getElementById('js-page-footer'),
		mainScroll: document.getElementById('js-main-scroll'),
		mainWrapper: document.getElementById('js-main-wrapper')
	},
	selectors: {
		productCard: '.js-card-project',
		pageWrapper: '.page__wrapper',
		smoothScrollbarTarget: '.js-smooth-scroll-target',
		mainScrollElementId: 'js-main-scroll',
		customSelectSelector: '.js-select',
		toTopButton: '.js-scroll-to-top',
		searchForm: '.js-search-form'
	},
	localStorage: {
		lastScrollTop: 'lastScrollTop'
	}
};

export default variables;
